import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import {
  getDatabaseEnvironment,
  getFrontendEnvironment,
} from 'util/environment';
import { useGlobalStore } from './store';
import { debugInfoQueries } from 'hooks/backend/debugInfo';

export function useSyncEnvStore() {
  const { data } = useQuery(debugInfoQueries.get);

  useEffect(() => {
    if (data) {
      useGlobalStore.setState({
        envs: {
          frontendEnv: getFrontendEnvironment(),
          backendEnv: data.backendEnv,
          databaseEnv: getDatabaseEnvironment(data.databaseEnv),
        },
      });
    }
  }, [data]);
}
